var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"background"}),_vm._v(" "),_c('SubscriptionPopUp',{attrs:{"orderData":_vm.orderData},on:{"close":_vm.close}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }